<template>
  <div class="FMP_WRAPPER" :style="wrapperStyles">
    <div class="FMP" :style="styles"></div>
  </div>
</template>

<script>
export default {
  name: 'first-meaningfull-paint',
  props: {
    wrapperStyles: {
      type: Object,
      default: () => {},
    },
    styles: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss">
.FMP_WRAPPER {
  .FMP {
    background: #f3f3f3;
    min-width: 20px;
    -webkit-animation: fmpLoading 1.5s ease-in infinite;
    animation: fmpLoading 1.5s ease-in infinite;
    &:after {
      content: '';
      display: inline-block;
      width: 100%;
      height: 100%;
      position: relative;
      z-index: -1;
    }
  }
}

@keyframes fmpLoading {
  0% {
    background-color: #f3f3f3;
  }
  50% {
    background-color: #e5e5e5;
  }
  100% {
    background-color: #f3f3f3;
  }
}
</style>
